<script setup>

import {computed, onMounted, ref, watch} from "vue";
import ButtonPrimary from "../../../buttons/buttonPrimary.vue";
import MediaBankEntry from "./util/media-bank-entry.vue";

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: true,
    }
})

const course = ref(null);
const courseLoaded = ref(false);
const userIsLoggedIn = window.myflow.user.loggedIn;
const pageBuilderActive = window.myflow.pagebuilderActive

const loadCourse = async () => {
    try {
        const res = await axios.get(route('api.course.customerarea.show', props.content.courseId));
        if (res.data.success)    {
            course.value = res.data.course
        }
    } catch (error) {

    }
    courseLoaded.value = true
};

const updateCompletion = async (chapter) => {
    await axios.post(route('api.course.customerarea.chapter.toggle-completed', [props.content.courseId, chapter.id]))
}

watch(() => props.content.courseId, () => {
    if (props.content.courseId) {
        loadCourse();
    }
}, { immediate: true });

onMounted(() => {
    if (userIsLoggedIn) {
        loadCourse();
    }
});

</script>

<template>
    <div>
        <div v-if="userIsLoggedIn">
            <div v-if="course">
                <h2 v-if="content.showCourseTitle">{{ course.title }}</h2>
                <ul  :class="content.displayMode === 'grid' ? 'grid grid-cols-2 gap-4 mt-2' : 'divide-y'">
                    <li
                        v-for="(chapter, i) in course.chapters"
                        :key="i"
                        class="flex"
                        :class="content.displayMode === 'grid' ? 'flex flex-col rounded-wl overflow-hidden border bg-white/50' : 'py-2 space-x-4 justify-between'"
                    >
                        <div>
                            <component
                                v-if="chapter.published && chapter.available"
                                :is="pageBuilderActive ? 'span' : 'a'"
                                :href="route('course.customerarea.chapter.show', [course.id, chapter.id])"
                                class="text-inherit cursor-pointer"
                            >
                                <img
                                    v-if="chapter.thumbnail_url"
                                    :src="chapter.thumbnail_url"
                                    alt=""
                                    :class="content.displayMode === 'grid' ? 'w-full aspect-video object-cover' : 'w-20 aspect-video mt-1 object-cover mr-2 float-left'"
                                />

                                <div
                                    :class="content.displayMode === 'grid' ? 'p-2' : ''"
                                >
                                    {{ chapter.title }}
                                </div>
                            </component>
                            <span
                                v-else
                                class="text-gray-400 cursor-not-allowed"
                                :class="content.displayMode === 'p-2' ? '' : ''"
                            >
                                {{ chapter.title }}
                            </span>
                        </div>
                        <span :class="content.displayMode === 'grid' ? 'p-2 mt-auto flex justify-end border-t mx-2' : 'flex items-center'">
                            <toggle-done
                                :content="chapter.completed"
                                @update:content="updateCompletion(chapter)"
                                class="shrink-0 w-5 h-5"
                            ></toggle-done>
                        </span>
                    </li>
                </ul>
            </div>
            <div v-else-if="courseLoaded && ! content.hideIfNotAvailable">
                <p>{{ content.courseNotAvailableMessage }}</p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
